
import DashboardPage from "features/dashboard/DashboardPage"



const Dashboard = () => {

    return (
        <>
            <DashboardPage />
        </>
        
    )
}

export default Dashboard